export default "__VITE_ASSET__x0_cMKOA__"